import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "@/hooks/use-toast";
import { updateUtilizedSessions } from "../services/update-utilized-sessions";

export function useUpdateUtilizedSessions() {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: ({
      usage_id,
      new_utilization_session__count,
    }: {
      usage_id: string;
      new_utilization_session__count: number;
    }) => updateUtilizedSessions(usage_id, new_utilization_session__count),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["user"], exact: false });
      toast({
        title: "Success",
        description: "Utilized session count updated",
      });
    },

    onError: (error: any) => {
      toast({
        title: "Error",
        description:
          error?.message || "Failed to update utilized session count",
        variant: "destructive",
      });
    },
  });
}
